<template>
  <main>
    <router-view name="HeaderView"></router-view>
    <!-- <router-view :key="$route.path"/> -->
    <router-view></router-view>
    <vue-progress-bar></vue-progress-bar>
  </main>
</template>

<script>
export default {
  setup(){}
};
</script>

<style>
main {
  overflow: hidden;
  min-height: 100vh;
}
</style>
